import {ref} from "vue";

export default function () {
    const showBlockTypeSelectModal = ref(false);
    let passBlockToSectionCallback;
    const openBlockTypeModal = (callback) => {
        showBlockTypeSelectModal.value = true;
        passBlockToSectionCallback = callback;
    };
    const templateSelected = (block) => {
        passBlockToSectionCallback(block)
    }
    return {
        showBlockTypeSelectModal,
        openBlockTypeModal,
        templateSelected
    }
}
